import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Task, TaskFilterInputObject, TaskScopeNameEnum } from 'graphql-common';
import Table from '@lib/components/Table/Table';
import useTasksQueryHook from 'utils/fetch/hooks/useTasksQueryHook';
import {
  ORDERING_PARAMS,
  PAGINATION_PARAMS,
  OrderingParams,
  PaginationParams,
} from '@lib/enums/urls';
import { APP_URLS } from 'constants/urls';
import getTaskTableColumns from './utils/getTaskTableColumns';
import getTaskTableActions from './utils/getTaskTableActions';

interface TaskDuplicationListProps {
  filters: TaskFilterInputObject[];
  isOpen: boolean;
  skip: boolean;
}

export function TaskDuplicationList(props: TaskDuplicationListProps) {
  const { filters, isOpen, skip } = props;
  const { t } = useTranslation();

  const paginationState = useState<PaginationParams>(() => ({
    ...PAGINATION_PARAMS,
  }));
  const orderingState = useState<OrderingParams>(() => ({
    ...ORDERING_PARAMS,
  }));
  const [paginationParams, setPaginationParams] = paginationState;
  const [orderingParams, setOrderingParams] = orderingState;

  useEffect(() => {
    if (!isOpen) {
      setPaginationParams({ ...PAGINATION_PARAMS });
      setOrderingParams({ ...ORDERING_PARAMS });
    }
  }, [isOpen, setPaginationParams, setOrderingParams]);

  const { collection, loading, totalCount } = useTasksQueryHook({
    additionalFilters: filters,
    scopeName: TaskScopeNameEnum.OnValidationOrValidated,
    skip: skip || !isOpen,
    paginationParams,
    orderingParams,
  });

  const onOpenTaskPage = (id?: string) => {
    if (id) {
      const to = APP_URLS.dashboard.tasks.view.getDynamicPath({
        pathParts: {
          id,
        },
      });
      window.open(to, '_blank')?.focus();
    }
  };

  const columns = getTaskTableColumns({ t, onOpenTaskPage });
  const actions = getTaskTableActions({ onOpenTaskPage });

  return (
    <Table<Task>
      actions={actions}
      data={collection}
      columns={columns}
      counterText={t('task-plural', { count: totalCount })}
      loading={loading}
      paginationState={paginationState}
      orderingState={orderingState}
      totalEntries={totalCount}
    />
  );
}
